// Formats a date (epoch ms or ISO string) as dd.MM.yyyy HH:mm in local time.
// Mirrors the legacy ToLocalDate helper.
export function toLocalDate(value?: number | string | null): string {
    if (!value && value !== 0) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const p = (n: number) => n.toString().padStart(2, '0');
    return `${p(date.getDate())}.${p(date.getMonth() + 1)}.${date.getFullYear()} ${p(date.getHours())}:${p(date.getMinutes())}`;
}
